import { useQuery } from '..';
import permissions from '../Apollo/permissions';
import { QUERY_WEBHOOK_CONFIG } from './query-webhook-config-builder';

export default function useQueryWebhookConfig(options = {}) {
  const { data, loading, error, refetch, isAllowed } = useQuery(QUERY_WEBHOOK_CONFIG, {
    context: { permission: permissions.readWebhookConfig },
    ...options,
  });
  // The backend table supports multiple configs per org, but the UI currently enforces a
  // single config. Extract only the first entry here to maintain that constraint.
  const webhookConfig =
    Array.isArray(data?.webhookConfigs) && data.webhookConfigs.length > 0 ? data.webhookConfigs[0] : null;

  return { webhookConfig, loading, error, refetch, isAllowed };
}
